//@ts-check
import { useQuery } from '@tanstack/react-query';

import getIndustries from '../../actions/get-industries';

/** @param {import('@tanstack/react-query').UseQueryOptions} [options] */
const useIndustries = (options = {}) => {
  /** @type {import('@action-types/industries').IndustriesQueryState} */
  const data = useQuery({
    ...options,
    queryKey: ['get-industries'],
    enabled: options.enabled ?? true,
    queryFn: async ({ signal }) => getIndustries({ signal }),
    staleTime: Infinity,
  });

  return data;
};

export default useIndustries;
